import type { SxProps, Theme } from "@mui/material";

// Full-viewport, vertically + horizontally centered column. Used for the app-bootstrap and auth
// loading/error screens (AuthGuard, both apps' AppBootstrap). Standard MUI tokens only.
export const centeredBoxSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  flexDirection: "column",
  gap: 2,
};
